// extracted by mini-css-extract-plugin
export var deleteIcon = "_oz-5";
export var deleteOption = "_oz-3";
export var divider = "_oz-2";
export var downloadIcon = "_oz-4";
export var drawer = "_oz-0";
export var drawerFooter = "_oz-6";
export var drawerOpen = "_oz-1";
export var highlighted = "_oz-7";
export var lighterHighlight = "_oz-8";